import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  surchargeInfo: {
    currency_code: string;
    price: number | string;
  };
}

export default function SurchargeRefundVariant({ surchargeInfo }: Props) {
  return (
    <Box id="SurchargeRefundVariant">
      <Typography>
        The surcharge of {surchargeInfo.currency_code} {surchargeInfo.price} will be refunded to customer
      </Typography>
    </Box>
  );
}
